import React, { Fragment } from 'react';
import DisplayCode1 from '../../../components/DisplayCode1/displayCode1';
import DisplayCode2 from '../../../components/DisplayCode2/DisplayCode2';

const Servicio_de_configuracion_obtener_condicion_EN = () => 
  {
    const codes ={
      answe_ok1: {
        title:"Answer ok",
        type: "json",
        code: `
        {
          "status": <boolean>,
          "codtran": <string>,
          "result": [
          "name": <string>,
          "id": <integer>
          ],
          "elapsed": <float>
          }`,
        copied: false
      },
      answe_ko1: {
        title:"Answer ko",
        type: "json",
        code: `
        {
          "status": <boolean>,
          "level": <string>,
          "message": <string>,
          "error": <string>
          }`,
        copied: false
      }
    };
  
    const codesMutiple={
      selected: {
        id: "python",
        type: "python",
        code: `import requests
        url = "URL_BASE/ws/admin.py/setgetconfig?country_code=MX&user_id=4532&session_id=443-L6Cc10xJ7rMGOM2tM9-v0g==&command=get_condition&condition=pais"
        payload = {}
        files = {}
        headers= {}
        response = requests.request("GET", url, headers=headers, data = payload, files = files)
        print(response.text.encode('utf8'))`
    },
      options: [
        {
          id: "python",
          type: "python",
          code: `import requests
          url = "URL_BASE/ws/admin.py/setgetconfig?country_code=MX&user_id=4532&session_id=443-L6Cc10xJ7rMGOM2tM9-v0g==&command=get_condition&condition=pais"
          payload = {}
          files = {}
          headers= {}
          response = requests.request("GET", url, headers=headers, data = payload, files = files)
          print(response.text.encode('utf8'))`
      },
          {
              id: "nodejs",
              type: "javascript",
              code: `var request = require('request');
              var options = {
              'method': 'GET',
              'url': 'URL_BASE/ws/admin.py/setgetconfig?country_code=MX&user_id=4532&session_id=443-L6Cc10xJ7rMGOM2tM9-v0g==&command=get_condition&condition=pais',
              'headers': {},
              formData: {}
              };
              request(options, function (error, response) { 
              if (error) throw new Error(error);
              console.log(response.body);
              });`
          },
          {
              id: "javascript",
              type: "javascript",
              code: `var formdata = new FormData();
              var requestOptions = {
              method: 'GET',
              body: formdata,
              redirect: 'follow'
              };
              fetch("URL_BASE/ws/admin.py/setgetconfig?country_code=MX&user_id=4532&session_id=443-L6Cc10xJ7rMGOM2tM9-v0g==&command=get_condition&condition=pais", requestOptions)
              .then(response => response.text())
              .then(result => console.log(result))
              .catch(error => console.log('error', error));`
          },
          {
            id: "curl",
            type: "bash",
            code: `curl --location --request GET 'URL_BASE/ws/admin.py/setgetconfig?country_code=MX&user_id=4532&session_id=443-L6Cc10xJ7rMGOM2tM9-v0g%3D%3D&command=get_condition&condition=pais'`
        }
      ]
    }
  
    return(
      <Fragment>
        <div className='container-fluid row'>
        <div className='col-md-7'>
        <h1 id="settings-service-to-obtain-a-condition">
          Settings Service to Obtain a Condition
        </h1>
        <p>
          This service is used to obtain the different values of the chosen
          condition.
        </p>
        <p>
          <span className="label get">GET:</span>
          <span> </span> <code>URL_BASE + /ws/admin.py/setgetconfig</code>
        </p>
        <h2 id="receives">Receives:</h2>
        <p>
          All parameters are sent in the call&#39;s querystring, so a percentage
          encoding for URI must be applied &#40;aka URL encoding&#41;.
        </p>
        <div className='overflow-auto'>
        <table>
          <thead>
            <tr>
              <th align="left">Parameter</th>
              <th align="center">Format</th>
              <th align="center">Obligatory</th>
              <th align="center">Description</th>
              <th align="center">Default value</th>
              <th align="center">Example</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td align="left">country_code</td>
              <td align="center">
                ISO 3166 alpha-2 &#40;
                <a href="https://www.iso.org/glossary-for-iso-3166.html">
                  https://www.iso.org/glossary-for-iso-3166.html
                </a>
                &#41;
              </td>
              <td align="center">Yes</td>
              <td align="center">Country code in which the user resides</td>
              <td align="center">N/A</td>
              <td align="center">ES &#40;Spain&#41;</td>
            </tr>
            <tr>
              <td align="left">user_id</td>
              <td align="center">Integer</td>
              <td align="center">Yes</td>
              <td align="center">Identifier of the user making the request</td>
              <td align="center">N/A</td>
              <td align="center">4532</td>
            </tr>
            <tr>
              <td align="left">session_id</td>
              <td align="center">String</td>
              <td align="center">
                Yes &#40;if you do not send signature to &#39;Access
                Service&#39;&#41;
              </td>
              <td align="center">
                Obtained by identifying the user with ID user_id on the platform
              </td>
              <td align="center">N/A</td>
              <td align="center">385-XadgYoWixbzN_wqWc3Yyog==</td>
            </tr>
            <tr>
              <td align="left">signature</td>
              <td align="center">String</td>
              <td align="center">
                Yes &#40;if you do not send session_id to &#39;Access
                Service&#39;&#41;
              </td>
              <td align="center">
                Enables you to sign the request without having to log in
              </td>
              <td align="center">N/A</td>
              <td align="center">00d4c87a1dd9c87ccda8518bb007835a71233069</td>
            </tr>
            <tr>
              <td align="left">command</td>
              <td align="center">String</td>
              <td align="center">Yes</td>
              <td align="center">
                It must contain the value <code>get_condition</code>
              </td>
              <td align="center">N/A</td>
              <td align="center">get_condition</td>
            </tr>
            <tr>
              <td align="left">condition</td>
              <td align="center">String</td>
              <td align="center">Yes</td>
              <td align="center">
                Condition from which we want the data to use it in the command{' '}
                <code>set</code>: country, channel, action, profile, user,
                affiliate_user, affiliate_service, origin_type
              </td>
              <td align="center">N/A</td>
              <td align="center">Location</td>
            </tr>
          </tbody>
        </table>
        </div>
        <h2 id="returns">Returns:</h2>
        <p>
          Depending on the result of the operation, this service can return two
          different JSON:
        </p>
        <h3 id="answer-json-ok">Answer JSON OK:</h3>
    
        <div className='mb-3'>
            <DisplayCode1 codeToshow={codes.answe_ok1}/>
          </div>
        <h2 id="where">Where:</h2>
        <ul>
          <li className="li-md" style={{fontSize:'1.2em', paddingLeft:'10px', marginLeft:'25px'}}>
            <code>status:</code> Shows if the call has been successful
            &#40;true&#41; or not &#40;false&#41;
          </li>
          <li className="li-md" style={{fontSize:'1.2em', paddingLeft:'10px', marginLeft:'25px'}}>
            <code>codtran:</code> Transaction code that identifies the executed
            operation
          </li>
          <li className="li-md" style={{fontSize:'1.2em', paddingLeft:'10px', marginLeft:'25px'}}>
            <code>result:</code> Executed service answer
          </li>
          <li className="li-md" style={{fontSize:'1.2em', paddingLeft:'10px', marginLeft:'25px'}}>
            <code>name:</code> Name of each data from the selected option.
          </li>
          <li className="li-md" style={{fontSize:'1.2em', paddingLeft:'10px', marginLeft:'25px'}}>
            <code>id:</code> Identifier of each data from the selected condition,
            will be sent within JSON <code>conditions</code> from command{' '}
            <code>set</code>.
          </li>
          <li className="li-md" style={{fontSize:'1.2em', paddingLeft:'10px', marginLeft:'25px'}}>
            <code>elapsed:</code> Execution operation time.
          </li>
        </ul>
        <h3 id="answer-json-ko">Answer JSON KO:</h3>
    
        <div className='mb-3'>
            <DisplayCode1 codeToshow={codes.answe_ko1}/>
          </div>
        <h2 id="where-1">Where:</h2>
        <ul>
          <li className="li-md" style={{fontSize:'1.2em', paddingLeft:'10px', marginLeft:'25px'}}>
            <code>status:</code> Shows if the call has been successful
            &#40;true&#41; or not &#40;false&#41;.
          </li>
          <li className="li-md" style={{fontSize:'1.2em', paddingLeft:'10px', marginLeft:'25px'}}>
            <code>level:</code> Error importance level.
          </li>
          <li className="li-md" style={{fontSize:'1.2em', paddingLeft:'10px', marginLeft:'25px'}}>
            <code>message:</code> Error message.
          </li>
          <li className="li-md" style={{fontSize:'1.2em', paddingLeft:'10px', marginLeft:'25px'}}>
            <code>error:</code> Sole error code.
          </li>
        </ul>
        <h2 id="business-logic">Business logic:</h2>
        <p>
          In order to run this service, it is necessary to do it from a user logged
          into the system who has an administrator profile. With this endpoint all
          the necessary data is obtained to indicate the condition in the creation
          of characteristics.
        </p>
        </div>

      <div className='col-md-5'>
        <h2 id="example-requests">Example requests:</h2>
        <div className='mb-3 effectStickySections'>
          <DisplayCode2 codeToshow={codesMutiple}/>
          </div>
       
        </div>
        </div>
      </Fragment>
    );
  }
export default Servicio_de_configuracion_obtener_condicion_EN;
